import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import { Modal } from 'react-bootstrap'

import closeIcon from 'Assets/x-icon-gray.svg'

import base from 'Styles/base.css'
import style from './style.css'

export default function TargetScoreWarningModal (props) {
  const divInline = {
    display: 'inline-block'
  }
  return (
    <Modal show={true} data-test-id="targetScoreAdjustedModal">
      <div className={style.containerModal}>
        <Modal.Header className={style.topicsHeader}>
          <Modal.Title className={style.title}>
            Target Score Adjusted
            <button
              data-test-id="closeWarningTargetScore"
              aria-label="Close Target Score Warning"
              className={classnames(style.closeWarningTarget, style.hideModal)}
              onClick={props.onCancelTargetScoreWarning}
              tabIndex="0"
            >
              <object
                data={closeIcon} type="image/svg+xml"
                className={base.svgIcon}
                tabIndex="-1"
              />
            </button>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className={style.text} tabIndex="0">
          Note that when you change the number of topics, the target score adjusts
          to 150 times the number of topics in the activity. This ensures that every
          student answers at least 5 questions for each topic.
          <span className={style.question}>
            If you would prefer a different target score, you can always change it.
            For more information about target
            scores,
            <span
              className={style.faq}
              onClick={props.onFaqClick}
              tabIndex="0"
              onKeyDown={(event) => onKeyDown(event, this)}
            >
              visit our FAQ
            </span>.
          </span>
        </Modal.Body>
        <Modal.Footer className={classnames('modal-footer', style.footerContainer)}>
          <div style={divInline}>
            <div className={style.buttonContainer}>
              <button
                className={classnames('btn-cdl-main', style.saveButton)}
                onClick={props.onCancelTargetScoreWarning}
                data-test-id="targetScoreAdjustedWorksForMe"
              >
                That works for me!
              </button>
            </div>
          </div>
          <div style={divInline}>
            <div className={style.buttonContainer}>
              <button
                className={classnames('btn-cdl-secondary', style.cancelButton)}
                onClick={props.onTargetScoreWarningClick}
                data-test-id="targetScoreAdjustedEditScoreBtn"
              >
                Edit Target Score
              </button>
            </div>
          </div>
        </Modal.Footer>
      </div>
    </Modal>
  )
}

function onKeyDown (event, obj) {
  if (event.keyCode === 13) {
    event.target.click()
  }
}

TargetScoreWarningModal.propTypes = {
  onTargetScoreWarningClick: PropTypes.func.isRequired,
  onCancelTargetScoreWarning: PropTypes.func.isRequired,
  onFaqClick: PropTypes.func.isRequired
}
